// let's go!
import React from 'react';
import {render} from 'react-dom';
import Router from './components/Router.js';
import './css/style.css';


render(<Router />, document.getElementById('main'));